
/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointEditorStoreExtensions" />

import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { cloneEndpoint } from "./EndpointsEditorPanelUtils";

/* tslint:disable:no-invalid-this */

declare module "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore" {
    export interface EndpointsEditorStore {
        getEndpoint(): ServiceEndpoint;
        getEndpointClone(): ServiceEndpoint;
        isOpenToAllPipelines(): boolean;
    }
}

EndpointsEditorStore.prototype.getEndpoint = function(): ServiceEndpoint {
    const state = this.getState();
    return state.serviceEndpoint;
};

EndpointsEditorStore.prototype.getEndpointClone = function(): ServiceEndpoint {
    const endpoint = this.getEndpoint();
    return cloneEndpoint(endpoint);
};

EndpointsEditorStore.prototype.isOpenToAllPipelines = function(): boolean {
    const state = this.getState();
    return state.openToAllPipelinesFlag;
};